import React, { Component } from "react";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import { Loader, Toastr } from "arv-reactcomponents";

import BrandListComponent from "./BrandsListComponent";

import { BRANDSLIST } from "npmlinks-constants";

@inject("StaticPageStore", "CommonStore")
@observer
class BrandsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showBrandFlow: false,
    };
  }

  componentDidMount() {
    const { id = null } = this.props.CommonStore.brandDetails;
    if (id) {
      this.props.StaticPageStore.setBrandFilterId(id);
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ showBrandFlow: true });
    }
    // eslint-disable-next-line no-unused-vars
    this.props.StaticPageStore.fetchBrandsListData().catch(error => {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: BRANDSLIST.ERROR_MSG,
        timeout: 3000,
      });
    });
  }

  get isBrandJourney() {
    const { id = "" } = this.props.CommonStore.brandDetails;
    return id && id.length;
  }

  get brandsListComponent() {
    const { showBrandFlow } = this.state;
    const brandListData = toJS(this.props.StaticPageStore.brandListObject);
    const data = this.props.StaticPageStore.filteredBrandList;
    if ((brandListData && brandListData.length) || (data && data.length)) {
      return <BrandListComponent.component isBrandJourney={showBrandFlow} />;
    }
    return <Loader className="nw-bodyoverlay-loadercontainer" />;
  }

  render() {
    return (
      <div className="nwc-main-content-wrapper">{this.brandsListComponent}</div>
    );
  }
}

BrandsList.wrappedComponent.propTypes = {
  StaticPageStore: PropTypes.shape({
    filteredBrandList: PropTypes.arrayOf().isRequired,
    fetchBrandsListData: PropTypes.func.isRequired,
    setBrandFilterId: PropTypes.func.isRequired,
    setSearchValue: PropTypes.func.isRequired,
    brandListObject: PropTypes.arrayOf().isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    brandDetails: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("StaticPageStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: BrandsList.wrappedComponent,
  component: BrandsList,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/index.js